module.exports = __webpack_public_path__ + "img/af.1d73ae27.svg";